import { Component, OnInit } from '@angular/core';
import {NgForm,FormsModule} from '@angular/forms';
import { Router,ActivatedRoute,Params } from '@angular/router';
import {commonService} from "../../service/common.service";
import { TopicService } from '../../service/topic.service';
import { Globals } from '../../globals';
import { HttpErrorResponse } from '@angular/common/http';

import { FileSelectDirective,FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
@Component({
  selector: 'app-savetopic',
  templateUrl: './savetopic.component.html',
  styleUrls: ['./savetopic.component.css'],
  providers:[TopicService,Globals,commonService]
})
export class SavetopicComponent implements OnInit {
  formData:any;
  formvailidation:any;
  topicId:any=0;
  isError=false;
  msg="";
  msgclass="alert-danger";
  mediaId:any=0;
  uploadimageName:any;
  uploaderror:any="";
  attachmentUrl =this.global.siteUrl+'file/upload?folder='+this.global.topicFolder+'&mediaFor=postTopic';
  
 
 

  uploader:FileUploader=new FileUploader({url:this.attachmentUrl,authToken:sessionStorage.getItem('_to')});
  fileExt:any = ['JPG','JPEG','PNG'];

  constructor(private router: Router,private route: ActivatedRoute,private topicservice:TopicService,private global: Globals,private commonService:commonService) {
    //console.log(this.attachmentUrl);
    this.formData={
      'category':'',
      'status':''
    }
    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);

    this.route.params.subscribe((params: Params) => {
      if(params['id']){
       this.topicId = parseInt( atob(params['id']));
      }
     // this.getForumDetail();
    });

   }

  ngOnInit() {  
    
    if(this.topicId > 0){
      this.getTopicDetail();

    }
 }

  


  savetopic(topicform:NgForm){
    this.msg="";
    console.log(topicform);
    this.formvailidation=false;
    if(topicform.valid==true){
      let saveobj={};
      if(topicform.value){

        for(let key in  topicform.value){
          saveobj[key]=topicform.value[key];
       
        }
      }
      if(this.uploadimageName){
        saveobj['image']=this.uploadimageName;
      }

      this.topicservice.saveTopic(saveobj,this.topicId,this.mediaId).subscribe((data:any)=>{
        console.log(data);


       
        if(this.topicId == 0){
          this.topicId=data.results.id;
          this.formData=saveobj;
          //let decodeid=this.customEnode(this.topicId);
          //let url='/admin/discussion/edittopic/'+decodeid;
         // this.router.navigate([url]);
        }else{
          if(saveobj['image']){
          this.formData['image']=saveobj['image'];
          }
        }



        this.uploadimageName="";
        this.mediaId=0;
        this.uploader.clearQueue();

        this.msg="Topic has been saved successfully";
        this.msgclass="alert-success";
        localStorage.setItem('isSuccess','Yes');
            localStorage.setItem('msg','Topic has been ' +data.message+ ' successfully.');
            this.router.navigate(['/admin/discussion/topic']);

      },(error:HttpErrorResponse)=>{
        this.isError = true;
        this.msg="internal server error!";
        this.msgclass="alert-danger";

      })
      


    }else{
      this.msg="Please fill required fields";
      this.msgclass="alert-danger";
    //  this.formvailidation=true;
    }

  }
  customEnode(data){

    return encodeURI(btoa(data));
  }

  getTopicDetail(){
    let obj={}
    obj['topicId']=this.topicId;
    this.topicservice.getTopicDetail(obj).subscribe((data:any)=>{
      console.log(data);
      if(data.error==0){ 
      this.formData=data.results;
        console.log(this.formData);
      }
    },
    (error : HttpErrorResponse)=>{
      this.isError = true;
      this.msg="internal server error!";
    })

  }

  ngAfterViewInit() {
    this.uploader.onAfterAddingFile = (item => {
       item.withCredentials = false;
    });
  }

  getTopicImage(imagename){
    return this.global.topicImageUrl+imagename;
    
  }
  /******************************* Image Upload *****************/
  onFileChanged(event) {
    this.uploaderror="";
  console.log(this.uploader.queue[0].file.name);
  var re = /(?:\.([^.]+))?$/;
  let ext=re.exec(this.uploader.queue[0].file.name)[1];
   
    if(this.fileExt.includes(ext.toUpperCase())){
      this.uploader.uploadAll();

    }else{
      this.uploaderror="Invalid Format. please upload jpg, jpeg, png file";
      this.uploader.clearQueue();
     
    }
  //
   }
 
  onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    console.log("Success");
      console.log(item); 
      let data = JSON.parse(response); //success server response
  
        if(data.error==0){
          console.log("set Ids");
          console.log(data.result);
          console.log(data.result.id);
          this.uploadimageName=data.result.uploadname;
          this.mediaId=data.result.id;        

        }
       
    }
  
    onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
        let error = JSON.parse(response); //error server response

        console.log(error);
    }




}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/discussion/savetopic/savetopic.component.ts